import { Injectable } from '@angular/core';

import { ApiService } from '../../../../../common/services/api.service';
import { environment } from 'src/environments/environment';
import { apiEndPoints } from '../../../../../common/constants/api-endpointsconstant';
import { ReportService } from 'src/app/reports/services/report.service';
import { LoaderType } from 'src/app/common/models/enums/common.enum';

@Injectable({
  providedIn: 'root'
})
export class ReportTenantProfilingService {

  constructor(
    private apiServive: ApiService,
    private reportService: ReportService
  ) { }

  getTotalTenantReport(year = null){
   
    const url: string = `${environment.miUrl}${apiEndPoints.mallTenantTotalReport}${this.reportService.filterQueryParams}`;
    return this.apiServive.get(url);
  }

  getMallTenantShareCategoryReport(year = null){
    let queryParams = {...this.reportService.queryParams};
    if(queryParams?.year){
      queryParams.year = year ? year : this.reportService.yearMaxValue(queryParams.year);
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    const url: string = `${environment.miUrl}${apiEndPoints.mallTenantShareCategoryReport}${changeParams}`;
    return this.apiServive.get(url);
  }

  getMallTenantLeaseRatePropertyTypeReport(year = null){
    let queryParams = {...this.reportService.queryParams};
    if(queryParams?.year){
      queryParams.year = year ? year : this.reportService.yearMaxValue(queryParams.year);
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    let url: string = `${environment.miUrl}${apiEndPoints.mallTenantLeaseRatePropertyTypeReport}${changeParams}`;
    return this.apiServive.get(url);
  }

  getMallTenantTrentAreaReport(year = null){
    let queryParams = {...this.reportService.queryParams};
    if(queryParams?.year){
      queryParams.year = year ? year : this.reportService.yearMaxValue(queryParams.year);
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    let url: string = `${environment.miUrl}${apiEndPoints.mallTenantTrentAreaReport}${changeParams}`;
    return this.apiServive.get(url);
  }
}
